import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import NavItemContent, {
  itemActiveStyles,
  itemStyles,
  Props as NavItemContentProps,
} from './NavItemContent';

const StyledButton = styled.button<{ isActive: boolean }>`
  ${itemStyles};
  padding: 0;

  ${({ isActive }) => isActive && itemActiveStyles};

  &:hover,
  &:focus {
    ${itemActiveStyles};
  }
`;

export interface Props extends NavItemContentProps {
  onClick: () => void;
  path?: string;
  id?: string;
}

function NavButton({
  onClick,
  icon,
  iconScale,
  text,
  notificationCount,
  path,
  showExclamationMark,
  ...rest
}: Props) {
  const match = useRouteMatch({ path });

  return (
    <StyledButton {...rest} isActive={Boolean(path && match)} onClick={onClick}>
      <NavItemContent
        icon={icon}
        iconScale={iconScale}
        text={text}
        notificationCount={notificationCount}
        showExclamationMark={showExclamationMark}
      />
    </StyledButton>
  );
}

export default NavButton;
